import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, useDataProvider } from 'react-admin';
import SelectBox from '../../CustomizedUIs/CustomSelectBox';

const useStyles = makeStyles(theme => ({
    textSelectBox: {
        height: '24px',
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: ' 0.13px',
        color: '#88898c',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    listItem: {
        padding: 8
    }
}));

const fakeList = [
    { id: 1, name: "None", value: "none" },
    { id: 2, name: "Daily", value: "Daily" },
    { id: 3, name: "Weekly", value: "Weekly" },
    { id: 4, name: "Monthly", value: "Monthly" },
];

const configurationList = [
    { id: 1, name: "Daily", value: "Daily" },
    { id: 2, name: "Weekly", value: "Weekly" },
    { id: 3, name: "Monthly", value: "Monthly" },
];

function SelectBoxInterval({ open, onSelect, recurrence, configuration }) {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles();

    // STATE
    const [expand, setExpand] = useState(false);
    const [list, setList] = useState(configuration ? configurationList : fakeList);
    // END STATE

    const onClick = (item) => {
        setExpand(false);
        onSelect(item)
    }

    // useEffect(() => {
    //     setList(recurrence)
    // }, []);

    if (!open) return null;
    return (
        <Box mt={4} mx={2.5}>
            <SelectBox
                label={translate(`pos.messages.recurrence`)}
                alignItems="center"
                open={expand}
                value={recurrence ? recurrence.name : ''}
                handleClick={() => setExpand(!expand)}
            >
                {
                    list.map(item => (
                        <Box key={'select-box-template-' + item.id} className={classes.boxBoder}>
                            <ListItem className={classes.listItem} button onClick={() => onClick(item)}>
                                <Typography className={classes.textSelectBox}>{item.name}</Typography>
                            </ListItem>
                        </Box>
                    ))
                }
            </SelectBox>
        </Box>
    )
}

SelectBoxInterval.propTypes = {
    open: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired
};

export default SelectBoxInterval;
